import React, {Component} from 'react';
import {List, Toast,NavBar,Checkbox,Modal} from 'antd-mobile';
import BMap from "BMap";
import './index.less';
import {connect} from "react-redux";
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class CityBillView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show:true,//发单预览地址，默认是显示
            refuse:false
        };
    }

    componentDidMount() {
        var map = new BMap.Map("allmap"); 
        map.centerAndZoom(new BMap.Point(116.404, 39.915), 11);
        map.setCurrentCity("北京");          // 设置地图显示的城市 此项是必须设置的
	    map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
    }
    color(res){
        if(res == "出发"){
            return "green"
        }else{
            return "orange"
        }
    }
    render() {
        return (
            <div className="cityBillView">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}></i>}
                >发单预览</NavBar>
                <div className="address">
               
                {
                    this.state.show ? 
        
                        <div className="addressBox">
                            <div><span>订单号</span> A8795412</div>
                            <div><span className="green">出发</span><div>官渡区新亚洲体育城新泽园</div></div>
                            <div><span  className="orange">到达</span><div>官渡区新亚洲体育城新泽园</div></div>
                        </div>
                        : null
                }
                    <div className="spread" onClick={()=>this.setState({show:!this.state.show})}>
                        {this.state.show ? <i className="icon iconfont iconzhedie"></i> : <i className="icon iconfont iconzhankai"></i> }
                    </div>
                </div>
                <div  id="allmap"></div>
                <div className="footerContent">
                    <div className="header">
                        <div>
                            <span>预计出发时间</span>
                            <div>2019-03-29 13:50</div>
                        </div>
                        <div>
                            <span>费用总计</span>
                            <p>¥75.00</p>
                        </div>
                    {
                        this.state.refuse ? 
                        <div>
                            <span>接单司机</span>
                            <div>张晓明 &nbsp;&nbsp;&nbsp;&nbsp;云A189674</div>
                        </div> :
                        <div>
                            <span>拒单次数</span>
                            <div>2</div>
                        </div>
                    }
                                
                            
                    </div>
                    <div className="footer">
                        <div>关闭订单</div>
                       {this.state.refuse ? <div>改派</div>:<div>派单</div> } 
                    </div>
                </div>
               
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/CityDispatch/CityBillView/index.js